import { createFileRoute } from '@tanstack/react-router'
import { ForumSection } from '~/components/marketing/forum-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { TasksSection } from '~/components/marketing/tasks-section'
import { TimelineSection } from '~/components/marketing/timeline-section'
import { VisitsSection } from '~/components/marketing/visits-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'O trabalho do escritório — projetos, tarefas e obras | Planno'
const PAGE_DESCRIPTION =
  'Projetos com pasta padrão, tarefas em sprints semanais, cronograma com macroetapas nativas, visitas técnicas no celular e timer para horas por projeto.'

export const Route = createFileRoute('/recursos/trabalho')({
  component: TrabalhoPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/recursos/trabalho',
      title: PAGE_TITLE,
    }),
})

function TrabalhoPage() {
  return (
    <MarketingShell>
      <ForumSection headingLevel="h1" />
      <TasksSection />
      <TimelineSection />
      <VisitsSection />
    </MarketingShell>
  )
}
